// @pdfme/ui rasterizes the base PDF with clawpdf (pdfium wasm) via
// @pdfme/converter. Both the converter web worker and clawpdf's wasm are loaded
// with `new URL(asset, import.meta.url)` from inside a dependency, which neither
// the Vite dev server nor the production build resolves correctly: in dev the
// URL lands next to .vite/deps (404), and in the deployed build the worker
// resolves its wasm relative to the SPA route and 404s ("PDF render worker
// failed"). So in BOTH environments we force clawpdf onto the main thread and
// point it at the wasm served/emitted by clawpdfWasmPlugin (web/vite.config.ts).
//
// These globals are read by the @pdfme/converter patch
// (.yarn/patches/@pdfme-converter-npm-*.patch). The patch also statically imports
// clawpdf so Vite includes it in the @pdfme/ui chunk instead of fetching a nested
// dynamic module that repeatedly failed on real mobile devices. The globals are
// set once at app entry, before any pdfme consumer loads, so every current and
// future pdfme surface gets the working configuration.
const pdfmeGlobals = globalThis as typeof globalThis & {
  __PDFME_FORCE_MAIN_THREAD__?: boolean
  __PDFME_WASM_URL__?: string
}
pdfmeGlobals.__PDFME_FORCE_MAIN_THREAD__ = true
// Content-hashed path injected by clawpdfWasmPlugin so browsers can never reuse
// a stale (or truncated) wasm across deploys, nor skew it against newer JS.
pdfmeGlobals.__PDFME_WASM_URL__ =
  process.env.PDFME_WASM_PATH ?? '/clawpdf/pdfium.esm.wasm'

export {}
